export default __webpack_public_path__ + "static/media/sunny_evening.aa9cf3ca.svg";